"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var formatField = function formatField(path, formatter) {
  return function (event) {
    if (!path || !formatter) return event;
    var currentValue = (0, _lodash.get)(event, path, '');
    if (!currentValue) return event;
    (0, _lodash.set)(event, path, formatter(currentValue));
    return event;
  };
};

var _default = formatField;
exports["default"] = _default;